module.exports = __webpack_public_path__ + "static/media/notification.638496d7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/notification.mp3
// module id = 1861
// module chunks = 0